import {
	doAjax, updateTableValue, initStitchesBackgroundColorListeners,
	changeStitchBackgroundColor, initRedPointLogic, fakeSelected, initColorSelect
} from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'

const initInteriorLeatherSelectLogic = () => {
	initColorSelect()
	loadAlreadyCustomizedOptions()
	const setYSJ = aeo['configuration']['YSJ'] === true
	const setYSJ_A6 = aeo['configuration']['YSJ_A6'] === true
	//const setYSI = aeo['configuration']['YSI'] === true
	//const setYSI_Q7Q8= aeo['configuration']['YSI_Q7Q8'] === true
	const setYSJ_Q7Q8= aeo['configuration']['YSJ_Q7Q8'] === true
	const setYSN = aeo['configuration']['YSN'] === true
	//const setYVK = aeo['configuration']['YVK'] === true


	
	if (setYSJ_A6) {

		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorUpperComponents = {
			doorRail: 'stitchDoorRail',
			instrumentPanelCover: 'stitchInstrumentPanelCover',
			doorArmRest: 'stitchDoorArmRest',
			bottomCenterConsole: 'stitchbottomCenterConsole'
		}
		for (const key in interiorUpperComponents) {
			const leatherComponent = key
			const stitchComponent = interiorUpperComponents[leatherComponent]
			const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
			const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode)
				setImage(component, colorCode)
			}
			initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
			initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId)
		}
	/*
	} else if (setYVK) {
			//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
			let interiorUpperComponents = {
				instrumentPanelCover: 'stitchInstrumentPanelCover',
				doorArmRest: 'stitchDoorArmRest',
				bottomCenterConsole: 'stitchbottomCenterConsole'
			}
			for (const key in interiorUpperComponents) {
				const leatherComponent = key
				const stitchComponent = interiorUpperComponents[leatherComponent]
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
				const callback = (component, colorCode) => {
					//checkSiblings(component, colorCode)
					setImage(component, colorCode)
				}
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
				initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
				initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId)
			}
	*/		
	} else if (setYSJ_Q7Q8) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorUpperComponents = {
			doorRail: 'stitchDoorRail',
			instrumentPanelCover: 'stitchInstrumentPanelCover',
			doorArmRest: 'stitchDoorArmRest',
			bottomCenterConsole: '',
			topCenterConsole: 'stitchbottomCenterConsole'
		}
		for (const key in interiorUpperComponents) {
			const leatherComponent = key
			const stitchComponent = interiorUpperComponents[leatherComponent]
			const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
			const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode)
				setImage(component, colorCode, "YSJ")
			}
			initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
			initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId)
		}
	} else if (setYSN) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorUpperComponents = {
			instrumentPanelCover: 'stitchInstrumentPanelCover',
		}
		for (const key in interiorUpperComponents) {
			const leatherComponent = key
			const stitchComponent = interiorUpperComponents[leatherComponent]
			const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
			const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
			const callback = (component, colorCode) => {
				//checkSiblings(component, colorCode)
				setImage(component, colorCode)
			}
			initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
			initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId)
		}
	} 
}

/**Returns the DOT ID for the component on params */
function getDotIdWithComponent(component) {

	switch (component) {
		case 'doorRail': return 'dot_tuerbrustung'
		case 'stitchDoorRail': return 'dot_naht-tierbruestung'
		case 'instrumentPanelCover': return 'dot_instru-abdeck'
		case 'stitchInstrumentPanelCover': return 'dot_naht-instru-abdeck'
		case 'doorArmRest': return 'dot_tuerarmauflage'
		case 'stitchDoorArmRest': return 'dot_tuerarmauflage-kontrastnaht'		
		case 'topCenterConsole': return 'dot_mittelkonsole-oben'
		case 'bottomCenterConsole': return 'dot_mittelkonsole-unten'
		case 'stitchbottomCenterConsole': return 'dot_mittelkonsole-unten-kontrastnaht'
		default: break;
	}	
}

function checkSiblings(component, colorCode) {
	const stitchComponents = ['stitchInstrumentPanelCover', 'stitchDoorRail']
	//const leatherComponents = ['instrumentPanelCover', 'doorRail']
	const leatherComponents = ['doorRail']
	const isStitchElement = stitchComponents.indexOf(component) != -1
	const setYSJ_A6temp = aeo['configuration']['YSJ_A6'] === true

	if (!setYSJ_A6temp) {

	if ((component != 'doorArmRest') && (component != 'stitchDoorArmRest') && (component != 'bottomCenterConsole') && (component != 'stitchbottomCenterConsole') && (component != 'topCenterConsole')) {
		if (areAllLeatherComponentsTheSameColor() && areAllStitchesComponentsTheSameColor()) {
			if (areAllLeatherComponentsDefaultColor() == true) {
				if (areAllStitchesComponentsDefaultColor() == true) {
					if (isStitchElement) {
						changeComponents(stitchComponents, colorCode)
					} else {
						changeComponents(leatherComponents, colorCode)
						changeComponents(stitchComponents, colorCode)

						changeStitchBackgroundColor(getDotIdWithComponent('stitchInstrumentPanelCover'), colorCode)
						changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorRail'), colorCode)
					}
				} else if (areAllStitchesComponentsDefaultColor() == false && isStitchElement == false) {
					changeComponents(leatherComponents, colorCode)

					changeStitchBackgroundColor(getDotIdWithComponent('stitchInstrumentPanelCover'), colorCode)
					changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorRail'), colorCode)
				}
				
			} else if (areAllLeatherComponentsDefaultColor() == false) {
				const selectedColor1 = document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code')
				const selectedStitchColor1 = document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
				if (isStitchElement && selectedColor1 == selectedStitchColor1) {
					changeComponents(stitchComponents, colorCode)
				}
			}
		}
	}
	}
}

/** This method will fake select the tile and change the components color for the components passed as parameter */
function changeComponents(components, colorCode) {
	components.forEach(component => {
		setImage(component, colorCode)
		fakeSelected(getDotIdWithComponent(component), colorCode)
	});
}

function setStitchColorPrimSec(component, colorCode) {
	setImage(component, colorCode) 
	fakeSelected(getDotIdWithComponent(component), colorCode)
}

/** updates component state and replaces its images with new color */
function setImage(component, colorCode, viewpackage) {
	// set leather color to stich 

	if (viewpackage == 'YSJ') {
		if(component == 'topCenterConsole' 
		&& (document.querySelector('#topCenterConsole td[color-code]').getAttribute('color-code') == document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
			|| document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code') == 99 )) {
				setStitchColorPrimSec('stitchbottomCenterConsole', colorCode)
		}
	} else {
		if(component == 'bottomCenterConsole' 
		&& (document.querySelector('#bottomCenterConsole td[color-code]').getAttribute('color-code') == document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
			|| document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code') == 99 )) {
				setStitchColorPrimSec('stitchbottomCenterConsole', colorCode)
		}
	}
	
	if(component == 'doorArmRest' 
		&& (document.querySelector('#doorArmRest td[color-code]').getAttribute('color-code') == document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
			|| document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code') == 99 )) {
		setStitchColorPrimSec('stitchDoorArmRest', colorCode)
	}

	if(component == 'doorRail' 
		&& (document.querySelector('#doorRail td[color-code]').getAttribute('color-code') == document.querySelector('#stitchDoorRail td[color-code]').getAttribute('color-code')
			|| document.querySelector('#stitchDoorRail td[color-code]').getAttribute('color-code') == 99 )) {
				setStitchColorPrimSec('stitchDoorRail', colorCode)
				setStitchColorPrimSec('stitchInstrumentPanelCover', colorCode)
	}

	const setYSJ_A6 = aeo['configuration']['YSJ_A6'] === true
	//onst setYSI = aeo['configuration']['YSI'] === true
	//const setYSI_Q7Q8 = aeo['configuration']['YSI_Q7Q8'] === true
	const setYSJ_Q7Q8 = aeo['configuration']['YSJ_Q7Q8'] === true
	const setYSN = aeo['configuration']['YSN'] === true	
	//const setYVK = aeo['configuration']['YVK'] === true	
	
	const carModel = document.querySelector("input[name=carmodel]").value;
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;

	//change image on frontseat
	if (setYSJ_A6) {
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSJ_A6_front_view'][colorCode]		
	}
	/*
	if (setYSI) {
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSI_front_view'][colorCode]		
	}
	if (setYSI_Q7Q8) {
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSI_Q7Q8_front_view'][colorCode]	
	}
	*/
	if (setYSJ_Q7Q8) {
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSJ_Q7Q8_front_view'][colorCode]
	}
	/*
	if (setYVK) {
		var imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YVK_front_view'][colorCode]		
		
		if(component == 'instrumentPanelCover' 
			&& (document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code') == document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
				 )) {
					setStitchColorPrimSec('stitchInstrumentPanelCover', colorCode)
		}
	}
	*/
	if (setYSN) {
		var imageSourceFront = aeo['images'][component + '_YSN_front_view'][colorCode]		
		
		if(component == 'instrumentPanelCover' 
			&& (document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code') == document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
				 )) {
					setStitchColorPrimSec('stitchInstrumentPanelCover', colorCode)
		}
	}


	replaceImage(imageSourceFront, component + "Color", 'car_frontseat')

	//change image on backseat
	const isComponentOnBackseat = ['bottomCenterConsole', 'doorRail', 'stitchDoorRail', 'doorArmRest', 'stitchDoorArmRest', 'topCenterConsole'].indexOf(component) != -1
	if (isComponentOnBackseat) {	
		if (setYSJ_A6) {
			if(['bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest','doorRail', 'stitchDoorRail'].indexOf(component) != -1) {
				var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSJ_A6_back_view'][colorCode]	
			}
		}
		/*
		if (setYSI) {
			if(['bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSI_back_view'][colorCode]		
			}
		}
		if (setYSI_Q7Q8) {
			if(['bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSI_Q7Q8_back_view'][colorCode]		
			}
		}
		*/
		if (setYSJ_Q7Q8) {
			if(['doorArmRest', 'stitchDoorArmRest','doorRail', 'stitchDoorRail', 'topCenterConsole', 'bottomCenterConsole'].indexOf(component) != -1) {
				var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSJ_Q7Q8_back_view'][colorCode]	
			}
		}		
		/*
		if (setYVK) {
			if(['bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				var imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YVK_back_view'][colorCode]	
			}
		}
		*/
		replaceImage(imageSourceBack, component + "Color", 'car_backseat')
	}

	//update table with new value
	updateTableValue(component, colorCode, 'interior-leather-components')

	//save component state
	doAjax({
		'interior_component': component,
		'color': colorCode,
		'src': imageSourceFront
	})
}


function areAllLeatherComponentsTheSameColor() {
		const selectedColor1 = document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code')
	const selectedColor2 = document.querySelector('#doorRail td[color-code]').getAttribute('color-code')
	return selectedColor1 == selectedColor2
}

function areAllLeatherComponentsDefaultColor() {
	const selectedColor1 = document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code')
	const firstComponentIsDefaultColor = selectedColor1 == aeo['default_color'].toString()
	return areAllLeatherComponentsTheSameColor() && firstComponentIsDefaultColor
}


function areAllStitchesComponentsTheSameColor() {
	const selectedStitchColor1 = document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
	const selectedStitchColor2 = document.querySelector('#stitchDoorRail td[color-code]').getAttribute('color-code')
	return selectedStitchColor1 == selectedStitchColor2
}

function areAllStitchesComponentsDefaultColor() {
	const selectedStitchColor1 = document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
	const firstStitchComponentIsDefaultColor = selectedStitchColor1 == aeo['default_color'].toString()
	return areAllStitchesComponentsTheSameColor && firstStitchComponentIsDefaultColor
}


export { initInteriorLeatherSelectLogic };
